import Box from '@mui/material/Box';
import animatedLoader from '../../static/assets/gif/animatedLoader.gif';
const AppLoader = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: '100vh',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <img src={animatedLoader} alt="Loading..." style={{ width: '120px', height: '120px' }} />

        </Box>
    );
};

export default AppLoader;
